module.exports = __webpack_public_path__ + "img/21000xxmtgjz.69343fa6.png";